import { createContext, useContext, useEffect, useState } from "react";
import { api, setAuthToken } from "@/lib/api";

const TOKEN_KEY = "cs_token";
const AuthCtx = createContext(null);

export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setReady(true);
      return;
    }
    setAuthToken(token);
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem(TOKEN_KEY);
        setAuthToken(null);
      })
      .finally(() => setReady(true));
  }, []);

  const login = (token, u) => {
    localStorage.setItem(TOKEN_KEY, token);
    setAuthToken(token);
    setUser(u);
  };

  const updateUser = (u) => setUser(u);

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setAuthToken(null);
    setUser(null);
    window.location.href = "/login";
  };

  return <AuthCtx.Provider value={{ user, ready, login, logout, updateUser }}>{children}</AuthCtx.Provider>;
}
